module.exports = __webpack_public_path__ + "img/add.b8750a3a.png";